import { Fragment, useCallback } from 'react';
import { useSelector } from 'react-redux';
import FeatureCard from 'marketplace-ui-apps-core/details/components/FeatureCard';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { FeatureCardCompatibility } from './FeatureCardCompatibility';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import useRequiredPlansForFeatures from 'marketplace-ui-apps-core/details/hooks/useRequiredPlansForFeatures';
import { useAppContext } from '../../../context/AppContext';
// @ts-expect-error untyped dependency
import { getIsCustomer } from '../../../selectors/auth';
import { jsx as _jsx } from "react/jsx-runtime";
export function IntegrationFeatures({
  features,
  integrationFeatures,
  isOpsHubListing,
  onTrackInteraction
}) {
  const appContext = useAppContext();
  const isCustomer = useSelector(getIsCustomer);
  const {
    requiredPlans,
    compatibilityLoading,
    compatibilityError
  } = useRequiredPlansForFeatures({
    appContext: appContext === 'admin-preview' ? 'public' : appContext,
    integrationFeatures: integrationFeatures || [],
    features: features || []
  });
  const featureCompatibilityRequestStatus = getDataFetchingClientRequestState(compatibilityError, compatibilityLoading);
  const renderFeatureCard = useCallback((feature, requiredPlan) => {
    const showFeatureCardCompatibility = feature.opsHubFeatures.length && isCustomer && isOpsHubListing;
    return /*#__PURE__*/_jsx(FeatureCard, {
      className: "m-bottom-8",
      feature: feature,
      onImageClick: () => onTrackInteraction('click integration feature screenshot', 'overview'),
      children: /*#__PURE__*/_jsx(LoadingWrapper, {
        requestStatus: featureCompatibilityRequestStatus,
        children: showFeatureCardCompatibility ? /*#__PURE__*/_jsx(FeatureCardCompatibility, {
          onTrackInteraction: onTrackInteraction,
          requiredPlan: requiredPlan
        }) : null
      })
    }, feature.title);
  }, [featureCompatibilityRequestStatus, isCustomer, isOpsHubListing, onTrackInteraction]);

  // if listingView.features is defined, Feature Editor features have been approved & published
  // and we should display those instead of the deprecated integrationFeatures
  if (features.length) {
    return /*#__PURE__*/_jsx(Fragment, {
      children: features.map((feature, index) => {
        // @ts-expect-error untyped dependency
        const requiredPlan = requiredPlans && requiredPlans[index];
        return renderFeatureCard(feature, requiredPlan);
      })
    });
  }
  return /*#__PURE__*/_jsx(Fragment, {
    children: integrationFeatures.map((integrationFeature, index) => {
      const {
        headline,
        text,
        imageUrl,
        hubSpotFeatures
      } = integrationFeature;
      // @ts-expect-error untyped dependency
      const requiredPlan = requiredPlans && requiredPlans[index];
      // put the deprecated integrationFeature
      // into the format expected by FeatureCard
      const feature = {
        type: 'MARKETPLACE_LISTING',
        title: headline,
        scopeGroups: [],
        opsHubFeatures: hubSpotFeatures,
        description: text,
        imageUrl,
        illustrationKey: '',
        guides: [],
        internal: {
          scopes: []
        }
      };
      return renderFeatureCard(feature, requiredPlan);
    })
  });
}